import { H2_LOGO } from "ui/src/assets";
import { Chain as BackendChainId } from "uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import {
  NetworkLayer,
  RPCType,
  UniverseChainId
} from "uniswap/src/features/chains/types";
import { ElementName } from "uniswap/src/features/telemetry/constants";
import { ONE_MINUTE_MS } from "utilities/src/time/time";
function getH2RpcUrl() {
  const isDevelopment = process.env.NODE_ENV === "development";
  const baseUrl = "https://rpc.h2chain.io";
  return baseUrl;
}
const h2Chain = {
  id: 2582,
  name: "H2",
  nativeCurrency: {
    decimals: 18,
    name: "eth",
    symbol: "H2"
  },
  rpcUrls: {
    default: {
      http: [getH2RpcUrl()]
    },
    public: {
      http: [getH2RpcUrl()]
    }
  },
  blockExplorers: {
    default: {
      name: "H2Scan",
      url: "https://lambda.h2scan.io"
    }
  },
  testnet: false
};
export const DEFAULT_NATIVE_ADDRESS = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";
export const H2_NATIVE_ADDRESS = "0x0000000000000000000000000000000000000000";
export const DEFAULT_RETRY_OPTIONS = { n: 10, minWait: 250, maxWait: 1e3 };
export const DEFAULT_MS_BEFORE_WARNING = ONE_MINUTE_MS * 10;
export function getChainInfo(chainId) {
  return UNIVERSE_CHAIN_INFO[chainId];
}
export const UNIVERSE_CHAIN_INFO = {
  [UniverseChainId.H2]: {
    ...h2Chain,
    id: UniverseChainId.H2,
    sdkId: 2582,
    // H2 Chain ID
    assetRepoNetworkName: void 0,
    // No asset repo for custom chain
    backendChain: {
      chain: BackendChainId.Ethereum,
      // Use Ethereum as fallback for H2 GraphQL queries
      backendSupported: true,
      // Enable backend support for H2
      isSecondaryChain: false,
      nativeTokenBackendAddress: H2_NATIVE_ADDRESS
    },
    blockPerMainnetEpochForChainId: 1,
    blockWaitMsBeforeWarning: DEFAULT_MS_BEFORE_WARNING,
    bridge: void 0,
    chainPriority: 0,
    // Highest priority
    docs: "https://docs.h2.io/",
    // Placeholder docs URL
    elementName: ElementName.ChainEthereum,
    // Reuse Ethereum element name for analytics
    explorer: {
      name: "H2Scan",
      url: "https://lambda.h2scan.io/",
      apiURL: void 0
    },
    helpCenterUrl: void 0,
    infoLink: "https://lambda.h2scan.io/",
    // Use explorer as info link
    infuraPrefix: void 0,
    // No Infura support
    interfaceName: "h2",
    label: "H2",
    logo: H2_LOGO,
    nativeCurrency: {
      name: "eth",
      symbol: "H2",
      decimals: 18,
      address: H2_NATIVE_ADDRESS,
      logo: H2_LOGO
    },
    wrappedNativeCurrency: {
      // 最小配置，用于 SDK 兼容性
      // 完整的 WH2 代币信息将从接口动态获取
      name: "Wrapped H2",
      symbol: "WH2",
      decimals: 18,
      address: "0x1e69ed5584b562da61c69433b6bb5430f351b1de"
    },
    networkLayer: NetworkLayer.L1,
    // Assuming H2 is L1
    pendingTransactionsRetryOptions: DEFAULT_RETRY_OPTIONS,
    rpcUrls: {
      [RPCType.Default]: {
        http: [getH2RpcUrl()]
      },
      [RPCType.Interface]: {
        http: [getH2RpcUrl()]
      },
      [RPCType.Public]: {
        http: [getH2RpcUrl()]
      }
    },
    urlParam: "h2",
    statusPage: void 0,
    spotPriceStablecoinAmount: void 0,
    // 不使用硬编码的价格基准
    stablecoins: [],
    // No stablecoins defined for H2 yet
    testnet: false,
    supportsInterfaceClientSideRouting: true,
    supportsGasEstimates: true
  }
};
export const GQL_MAINNET_CHAINS = Object.values(UNIVERSE_CHAIN_INFO).filter((chain) => !chain.testnet && !chain.backendChain.isSecondaryChain).map((chain) => chain.backendChain.chain).filter((backendChain) => !!backendChain);
export const GQL_TESTNET_CHAINS = Object.values(UNIVERSE_CHAIN_INFO).filter((chain) => chain.testnet && !chain.backendChain.isSecondaryChain).map((chain) => chain.backendChain.chain).filter((backendChain) => !!backendChain);
export const SUPPORTED_GQL_CHAINS = [...GQL_MAINNET_CHAINS, ...GQL_TESTNET_CHAINS];
